import { fetchRequest } from "@providers/conect";

const checkDuplicateApi = async (data) => {
  try {
    const url = `agendawp/check-duplicate`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: {
        ...data
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { checkDuplicateApi };